import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 mx-4" }
const _hoisted_2 = { class: "p-4 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-weight-500 text-center" }, [
  /*#__PURE__*/_createTextVNode("\n        パスワードリセットの認証が完了しました"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("パスワードを再設定してください\n      ")
], -1)

import { ref } from "vue";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { authStore } from "@/store/auth";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordSetting',
  setup(__props) {

const errorModal = useErrorModal();
const modal = useModal();
const loader = useLoader();
const customRouter = useCustomRouter();

const password = ref("");

async function nextStep() {
  try {
    loader.show();
    await registration();
    await modal.msgBoxOk(
      "パスワードの再設定が完了しました\n再度ログインしてください",
      {
        centered: true
      }
    );
    authStore.logout();
    await customRouter.pushIgnoreError({ name: "Welcome" });
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any;
    // smsSessionIdが不正な場合
    if (err.response?.data.smsSessionId) {
      await modal.msgBoxOk("不正な操作です", {
        centered: true
      });
      await customRouter.pushIgnoreError({ name: "Welcome" });
      return;
    }
    // それ以外の場合
    await errorModal.showErrorModal(err);
  } finally {
    loader.hide();
  }
}

function registration() {
  const body = {
    smsSessionId: authStore.smsSessionId as string,
    password: password.value
  };
  return authService.requestWorkerPasswordReset(body);
}

return (_ctx: any,_cache: any) => {
  const _component_AuthCompletion = _resolveComponent("AuthCompletion")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      パスワード再設定\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AuthCompletion)
      ]),
      _createTextVNode(),
      _hoisted_3,
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        ref: "form",
        tag: "div",
        class: "w-100"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(nextStep)), ["stop","prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(PasswordInputGroup, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                class: "mb-4"
              }, null, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(AppButton, {
                block: "",
                onClick: ($event: any) => (handleSubmit(nextStep))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            設定して次へ\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"])
            ], undefined, true),
            _: 2
          }, 1032, ["onSubmit"])
        ]),
        _: 1
      }, 512)
    ]),
    _createTextVNode(),
    _createVNode(BlockBack)
  ]))
}
}

})